import {  IOrganizationBillingListResponse } from "@/utils/types";
import { StoreType } from "..";

export const billingHistorySelector = (state: StoreType): IOrganizationBillingListResponse => state.organizationBillingStore.billingHistoryData as IOrganizationBillingListResponse;


